
/**
 * 자료 유형
 */
export type UploadEduMedia200AssetType = typeof UploadEduMedia200AssetType[keyof typeof UploadEduMedia200AssetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadEduMedia200AssetType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  MARKDOWN: 'MARKDOWN',
  PDF: 'PDF',
  ZIP: 'ZIP',
  PRESENTATION: 'PRESENTATION',
  SPREADSHEET: 'SPREADSHEET',
  OTHER_ASSET: 'OTHER_ASSET',
} as const;
